<template>
  <main class="main-section">
    <MenuBar />
    <section
      class="home-page"
      :style="{
        backgroundImage:
          'url(https://cdn.trailfinders.com/lhyeeujtsh_bg-home.jpg)',
      }"
    >
      <b-container class="main-cont nav-container">
        <!-- Try breadcrumb here -->
        <b-row v-if="showBreadcrumb">
          <b-col class="home-nav-container-header col">
            <Breadcrumbs />
          </b-col>
        </b-row>
        <!-- Text to display if a new travel centre is opening up in a clients postcode area -->
        <b-row v-if="newTravelCentreText">
          <b-col class="home-nav-container-header col">
            {{ newTravelCentreText }}
          </b-col>
        </b-row>
        <!-- Try Etrail banner here? -->
        <template v-if="$route.name !== 'communications' && !isBookingCancelled">
          <EtrailBanner />
        </template>
        <!--  -->
        <slot />
      </b-container>
    </section>
    <LoadingSpinner />
  </main>
</template>

<script>
import MenuBar from "@/modules/menu-bar";
import LoadingSpinner from "@/partials/spinner";
import EtrailBanner from "@/modules/navigation/etrail.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    MenuBar,
    LoadingSpinner,
    EtrailBanner,
  },
  computed: {
    ...mapGetters("booking", ["getUserInfo", 'isBookingCancelled']),
  },
  updated() {
    const info = this.getUserInfo;
    if (info && info.newTravelCentre) {
      this.newTravelCentreText = info.newTravelCentre;
    }
  },
  data() {
    return {
      newTravelCentreText: "",
      showBreadcrumb : this.$route.name !== 'passwordChange'
    };
  },
};
</script>

<style scoped>
@import "./styles.scss";
</style>
